export const LITE_APP_NOT_OPEN = -1 // 小程序未开通
export const LITE_APP_PUBLIC = 1 // 公共版
export const LITE_APP_SHARE = 2 // 专享版
